import { Stack } from "@ui/Stack";
import "./ClipCount.css";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Text } from "@ui/typography/Text";

type Props = {
	clipCount: number;
	/** Printed before the count, e.g. "Clips added:". */
	label?: string;
};

export const ClipCount = (props: Props) => {
	return (
		<Stack
			direction="row"
			spacing="small"
			align="center"
			class="gvtui-clip-count"
		>
			<MaterialSymbol symbol="movie" />
			<Text
				family="mono"
				size="small"
				weight="bold"
				style={{ color: "inherit" }}
			>
				{props.label ? `${props.label} ${props.clipCount}` : props.clipCount}
			</Text>
		</Stack>
	);
};
